import { ReactComponentManifest } from "web/entrypoints/common/setup";
import { Editorial } from "web/react/pages/editorial";
import withRedux from "web/react/redux-provider";

export const editorialComponents: ReactComponentManifest = {
    Editorial: withRedux(Editorial),
};
